//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "../../services/api";
import { server } from "../../services/constants";

export default {
  data() {
    return {
      isBeForMenu: "",
      isDoubleClicked: false,
      isClicked: false,
      // ⭐ เดิมเป็น array เมนู hardcode ทั้งหมด (~700 บรรทัด)
      // ตอนนี้ดึงจาก backend ผ่าน api.getMenuTree() แทน ดู loadMenus()
      menus: [],
      selectedMenu: null,
    };
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    },
  },
  watch: {
    "$store.state.company_id"() {
      this.loadMenus();
    },
    $route(to, from) {
      this.selectedMenu = this.menus.findIndex(
        (menu) => menu.items.findIndex((item) => item.route == to.path) != -1,
      );
    },
  },
  async mounted() {
    try {
      this.$store.state.modelmenu = parseInt(
        localStorage.getItem(server.MODELMENU),
      );

      await this.loadMenus();
    } catch (error) {
      console.error("Menu.vue mounted error:", error);
    }
  },
  methods: {
    /**
     * ⭐ ใหม่: ดึงเมนู (group + submenu) จาก backend ตามสิทธิ์ของ user ที่ login
     * แทนการ fix ค่าใน data() -> menus: []
     * ใช้ AUTHORIZE_ID (= setting_group_menu_id ที่ผูกไว้ตอน login) + COMPANYID
     */
    async loadMenus() {
      try {
        const setting_group_menu_id = localStorage.getItem(server.AUTHORIZE_ID);
        const company_id = localStorage.getItem(server.COMPANYID);

        if (!company_id) {
          console.warn("Menu.vue: ไม่พบ COMPANYID กรุณาเลือกบริษัทหรือ login ใหม่");
          this.menus = [];
          return;
        }

        const user_id = localStorage.getItem(server.USER_ID);
        // backend จะรู้เองจาก token ว่าเป็น super admin หรือไม่
        const res = await api.getMenuTree(setting_group_menu_id || 0, company_id, user_id);
        const rawMenus = (res.data && res.data.menus) || [];

        this.menus = rawMenus
          .filter((menu) => menu.cgm_show_menu !== false)
          .map((menu) => ({
            ...menu,
            items: (menu.items || []).filter((s) => s.cmd_show_menu !== false),
          }))
          .filter((menu) => menu.route || menu.items.length > 0);
      } catch (error) {
        console.error("Menu.vue loadMenus error:", error);
        this.menus = [];
      }
    },

    onMouseEnter() {
      if (!this.isClicked) {
        this.isDoubleClicked = false;
        this.$store.state.Drawer = false;
      }
    },
    onMouseLeave() {
      if (!this.isClicked) {
        this.$store.state.Drawer = true;
      }
    },

    onClickMenuItem(link, mode) {
      this.isClicked = true;
      localStorage.setItem(server.MODELMENU, link.index);

      this.$router.push(link.route).catch((err) => { });

      if (mode == `mainmenu`) {
        if (link.items.length == 0) {
          setTimeout(() => {
            this.isClicked = false;
          }, 50);
        } else {
          if (this.isBeForMenu == link.title) {
            this.isDoubleClicked = !this.isDoubleClicked;
          } else {
            this.isDoubleClicked = true;
            this.isBeForMenu = link.title;
          }

          if (!this.isDoubleClicked) {
            setTimeout(() => {
              this.isClicked = false;
            }, 50);
          }
        }
      } else {
        this.isDoubleClicked = !this.isDoubleClicked;
        this.isClicked = false;
        this.$store.state.Drawer = true;
      }
    },

    onClickLogo() {
      this.isDoubleClicked = false;
      this.isClicked = true; // ตั้งค่า isClicked เป็น true เมื่อคลิกโลโก้
      this.$store.state.Drawer = true; // ตั้งค่า Drawer เป็น true

      setTimeout(() => {
        this.isClicked = false; // คืนค่าเป็น false หลังจากเวลาที่กำหนด
      }, 500); // หน่วงเวลา 500ms หลังจากคลิก
    },
    closeSubMenu() {
      this.$store.state.Drawer = true;
      setTimeout(() => {
        this.isClicked = false; // คืนค่าเป็น false หลังจากเวลาที่กำหนด
      }, 50);
    },
  },
};
